import { gql } from 'graphql-tag'

export const REVOKE_PUSH_TOKEN = gql`
  mutation revokePushToken($platform: String, $token: String!) {
    revokePushToken(platform: $platform, token: $token)
  }
`
